import * as React from "react";
const SvgFiRrCamera = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-camera_svg__a)">
      <path d="M19 4h-.508l-2.184-2.832A3.02 3.02 0 0 0 13.932 0h-3.864a3.02 3.02 0 0 0-2.376 1.168L5.508 4H5a5.006 5.006 0 0 0-5 5v10a5.006 5.006 0 0 0 5 5h14a5.006 5.006 0 0 0 5-5V9a5.006 5.006 0 0 0-5-5M9.276 2.39a1 1 0 0 1 .792-.39h3.864a1 1 0 0 1 .792.39L15.966 4H8.034zM22 19a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3z" />
      <path d="M12 8a6 6 0 1 0 0 12 6 6 0 0 0 0-12m0 10a4 4 0 1 1 0-8 4 4 0 0 1 0 8" />
    </g>
    <defs>
      <clipPath id="fi-rr-camera_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCamera;
